var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnimateur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.88086 19.8647C5.18625 17.2689 7.3863 15.3125 10.0001 15.3125H20.0001C22.6139 15.3125 24.8139 17.2689 25.1194 19.8647L25.9311 26.7655C25.9916 27.2796 25.6239 27.7456 25.1096 27.8061C24.5954 27.8666 24.1295 27.4988 24.069 26.9845L23.2571 20.0839C23.0629 18.4323 21.6631 17.1875 20.0001 17.1875H10.0001C8.33709 17.1875 6.93732 18.4323 6.74301 20.0839L5.93117 26.9845C5.87067 27.4988 5.40477 27.8666 4.89055 27.8061C4.37632 27.7456 4.00851 27.2796 4.06901 26.7655L4.88086 19.8647Z",
    fill: "#A70606"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 12.5C17.7614 12.5 20 10.2614 20 7.5C20 4.73858 17.7614 2.5 15 2.5C12.2386 2.5 10 4.73858 10 7.5C10 10.2614 12.2386 12.5 15 12.5Z",
    fill: "#A70606"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M10 17.1875V22.5C10 24.857 10 26.0355 10.7322 26.7677C11.4645 27.5 12.643 27.5 15 27.5C17.357 27.5 18.5355 27.5 19.2677 26.7677C20 26.0355 20 24.857 20 22.5V17.1875H10Z",
    fill: "#A70606"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnimateur);
export default __webpack_public_path__ + "static/media/animateur.2c7003376654b71943357de996776a49.svg";
export { ForwardRef as ReactComponent };